<template>
  <div class="container" :class="!$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-1'">
    <v-tabs
      v-model="parent_tab"
      background-color=""
      hide-slider
      active-class="tab-bg-color"
      color="primary"
      grow
      class="tab-border pb-2"
    >
      <v-tab v-for="item in items" :key="item">
        <div class="text-capitalize parent_tab-text">
          {{ item }}
        </div>
      </v-tab>
    </v-tabs>

    <v-tabs
      class="child-tabs"
      v-model="child_tab"
      background-color="transparent"
      color="#2d8cff"
      grow
    >
      <v-tab v-for="item in child_tabs" :key="item.id">
        <div class="text-capitalize child-tab-text">
          {{ item.name }}
        </div>
      </v-tab>
    </v-tabs>
    <!-- {{ this.child_tabs[child_tab] }} -->
    <!-- {{ current_tab }} -->

    <v-tabs-items
      class="pt-2 mt-2"
      style="background-color: transparent"
      v-model="child_tab"
      :touchless="is_draggable"
    >
      <v-tab-item v-for="item in child_tabs" :key="item.id">
        <v-card background-color="transparent" class="">
          <WatchListSearch
            v-if="item.name != 'Nifty 50'"
            :watchlist_id="item.id"
            :current_tab="tab"
            :parent_tab="parent_tab"
            :parent_tab_value="selectedTab"
            :stock_data="items_data"
          >
          </WatchListSearch>
          <div v-if="items_loading" class="text-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <div
            v-if="items_data.length == 0 && item.name != 'Nifty 50'"
            class="d-flex justify-center flex-column align-center pb-0"
            :style="items_data.length == 0 ? 'height: 80dvh' : ''"
          >
            <div class="search-img mb-3">
              <v-img :src="search_img"> </v-img>
            </div>
            <div class="mt-4">
              <div class="search-security">Search Securities</div>
              <div class="search-security-desc">
                Use the search bar to add securities to your watchlist
              </div>
            </div>
          </div>
          <Nifty50WatchlistTable
            v-if="mainTab == 'Securities' && item.name == 'Nifty 50'"
          >
          </Nifty50WatchlistTable>
          <StocksWatchListTable
            :is_Nifty="item.name"
            :stock_data="items_data"
            :is_drag="is_draggable"
            v-if="mainTab == 'Securities'"
            :total_page="stock_total_page"
            :page="page"
            :stock_page="stock_page"
            :hides="hide"
          >
            <!-- :page_info="page_infos" -->
            <!-- @appendStocksTable="appendStocksTable(false)" -->
          </StocksWatchListTable>
          <TradesWatchlistTable
            :stock_data="items_data"
            :total_page="stock_total_page"
            :page="page"
            :is_drag="is_draggable"
            :closed_trades="closed_data"
            :closed_page="closed_page"
            :closed_total_page="closed_total_page"
            :watchlist_id="item.id"
            v-if="mainTab == 'Trades'"
          >
          </TradesWatchlistTable>
          <TradersWatchlistTable
            :total_page="stock_total_page"
            :page="page"
            :returnTabId="returnTabId"
            :stock_data="items_data"
            :is_drag="is_draggable"
            v-if="mainTab == 'Traders'"
          >
          </TradersWatchlistTable>
          <!-- <div class="text-center">
            <v-pagination v-model="page" :length="10" circle></v-pagination>
          </div> -->
          <!-- <div
            class="text-center"
            v-if="
              page_infos.page < page_infos.total_page && mainTab != 'Nifty 50'
            "
          >
            <v-progress-circular
              indeterminate
              color="#2f80ed"
            ></v-progress-circular>
            Loading More...
          </div> -->
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import Axios from "@/api/BaseAxios.js";
import apiUrl from "@/common/apiUrl";

export default {
  name: "NewWatchlistComponent",
  props: {
    user_id: {
      type: Number,
      required: true,
    },
  },
  components: {
    StocksWatchListTable: () => import("./StocksWatchListTable.vue"),
    Nifty50WatchlistTable: () => import("./Nifty50Table.vue"),
    TradesWatchlistTable: () =>
      import(
        "@/components/Profile/ProfileTradeDetails/Wacthlist/TradesWatchlistTable.vue"
      ),
    TradersWatchlistTable: () =>
      import(
        "@/components/Profile/ProfileTradeDetails/Wacthlist/TradersWatchlistTable.vue"
      ),
    WatchListSearch: () =>
      import(
        "@/components/Profile/ProfileTradeDetails/Wacthlist/NewWatchListSearch.vue"
      ),
  },
  data() {
    return {
      parent_tab: null,
      child_tab: null,
      is_draggable: false,
      draggable: false,
      items: ["Securities", "Traders", "Trades"],
      closed_page: 1,
      closed_total_page: 1,
      current_tab: null,
      child_tabs: [],
      nifty50: {
        category: 1,
        id: 1,
        name: "Nifty 50",
      },
      search_img: require("@/assets/images/SearchWatchlist.svg"),
      // page_info: {
      //   page: 1,
      //   total_page: 1,
      // },
      hide: true,
      page: 1,
      page_infos: {
        page: 1,
      },
      stock_page: 1,
      stock_total_page: 1,
      items_loading: false,
      nifty_loading: false,
      trader_page_info: {
        total_page: 1,
        page: 1,
      },
      items_data: [],
      closed_data: [],
      get_duration: [],
      exchange: null,
      status: null,
      duration: null,
      alpha: "",
      percentChange: null,
      ltp: null,
      profit_loss: null,
      closed: null,
      accuracy: null,
      holding_period: null,
      risk_reward: null,
      avg_trade: null,
      roi: null,
    };
  },

  computed: {
    tab() {
      this.setDraggableFalse();
      let tabs = this.child_tabs[this.child_tab];
      var keys = Object(tabs);

      if (keys.id) {
        this.getWatchlistItems(keys.id);
      }
      if (this.selectedTab == "trade" && keys.id) {
        this.getTradesClosedWatchlistItems(keys.id);
      }
      return keys.name;
    },
    returnTabId() {
      let tabs = this.child_tabs[this.child_tab];
      var keys = Object(tabs);
      return keys.id;
    },
    mainTab() {
      this.setDraggableFalse();
      return this.items[this.parent_tab];
    },
    selectedTab() {
      switch (this.mainTab) {
        case "Securities":
          return "stock";
        case "Traders":
          return "trader";
        default:
          return "trade";
      }
    },
  },

  mounted() {
    this.getDurationList();
    // this.onIntersects([{ isIntersecting: true }]);
    // console.log(this.page_infos);
  },

  methods: {
    // onIntersects(entries) {
    //   this.hide = true;
    //   entries.forEach((entry) => {
    //     if (entry.isIntersecting) {
    //       if (this.page_infos.page < this.page_infos.total_page) {
    //         console.log(this.page_infos.page, "page");
    //         this.page_infos.page += 1;
    //         let tabs = this.child_tabs[this.child_tab];
    //         var keys = Object(tabs);
    //         this.getWatchlistItems(keys.id, true);
    //       } else {
    //         this.hide = false;
    //       }
    //     }
    //   });
    // },
    getId(id) {
      return id;
    },
    setDraggableFalse() {
      this.is_draggable = false;
    },

    getWatchlistTabs() {
      const successHandler = (res) => {
        this.child_tabs = res.data;
        if (this.parent_tab == 0) {
          // console.log("parenttab", this.parent_tab);
          this.child_tabs.unshift(this.nifty50);
        }
      };
      const failureHandler = () => {};
      let formData = {};
      formData["category__watchlist_type"] = this.selectedTab;
      formData["profile__user__id"] = this.user_id;
      Axios.request_GET(
        "watchlist/detail/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    getDurationList() {
      const successHandler = () => {
        // console.log(res);
      };
      const failureHandler = () => {};
      let formData = {};

      Axios.request_GET(
        apiUrl.GET_DURATION_LIST,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },

    getTradesClosedWatchlistItems(id) {
      const successHandler = (res) => {
        this.closed_data = res.data.result;
        this.closed_total_page = res.data.total_page;
        // console.log(this.closed_total_page, "closed p");
      };
      const failureHandler = () => {};
      let formData = {};

      let ordering = [];

      ordering.push(
        this.alpha,
        this.percentChange,
        this.ltp,
        this.profit_loss,
        this.closed,
        this.accuracy,
        this.holding_period,
        this.risk_reward,
        this.avg_trade,
        this.roi
      );

      let orders = [];
      for (let i = 0; i < ordering.length; i++) {
        if (ordering[i]) {
          orders.push(ordering[i]);
        }
      }
      if (orders.length != 0) {
        formData["ordering"] = orders.join(",");
      }

      formData["watchlist"] = id;

      formData["trade__security__exchange"] = this.exchange;
      formData["trade__status"] = this.status;
      formData["trade__duration"] = this.duration;
      formData["page_number"] = this.closed_page;

      formData["status"] = "Closed";
      Axios.request_GET(
        "watchlist/items/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },

    getWatchlistItems(id, is_append) {
      this.items_loading = true;
      // console.log(counts);
      // console.log("watchlist");
      // if (is_append) {
      // }
      const successHandler = (res) => {
        // console.log(is_append, "append");
        // if (!is_append) {
        // if (this.page_infos.page <= 1) {
        if (!is_append) {
          // console.log(!is_append, "append");
          this.items_data = res.data.result;
          this.items_loading = false;
        } else {
          res.data.result.forEach((value) => {
            this.items_data.push(value);
          });
          this.items_loading = false;

          // console.log(this.items_data);
        }
        // let total_page = res.data.total_page;

        this.stock_total_page = res.data.total_page;
      };
      const failureHandler = () => {};
      let formData = {};

      formData["watchlist"] = id;
      // if(this.page_infos.page)
      formData["page_number"] = this.page;

      // if (!is_append) {
      //   formData["page_number"] = this.stock_page;
      // } else {
      //   formData["page_number"] = counts;
      // }
      let ordering = [];

      ordering.push(
        this.alpha,
        this.percentChange,
        this.ltp,
        this.profit_loss,
        this.closed,
        this.accuracy,
        this.holding_period,
        this.risk_reward,
        this.avg_trade,
        this.roi
      );
      let orders = [];
      for (let i = 0; i < ordering.length; i++) {
        if (ordering[i]) {
          orders.push(ordering[i]);
        }
      }
      if (orders.length != 0) {
        formData["ordering"] = orders.join(",");
      }

      if (this.selectedTab == "stock") {
        formData["stock__exchange"] = this.exchange;
      } else if (this.selectedTab == "trade") {
        formData["trade__security__exchange"] = this.exchange;
        formData["trade__status"] = this.status;
        formData["status"] = "Active";
        formData["trade__duration"] = this.duration;
      } else {
        // formData["trade__status"] = this.status;
      }
      Axios.request_GET(
        "watchlist/items/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },

    deleteWatchlistItems(id) {
      const successHandler = () => {
        this.items_data.filter((item, index) =>
          item.id == id ? this.items_data.splice(index, 1) : ""
        );
      };
      const failureHandler = () => {};
      let formData = {};

      formData["id"] = id;
      Axios.request_DELETE(
        "watchlist/items/",
        formData,
        {},
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },

    appendStocksTable(value) {
      console.log(value, "value");
    },
  },
  watch: {
    parent_tab(value) {
      // this.page_infos.page = 1;
      // this.page_infos.total_page = 1;
      this.getWatchlistTabs();
      this.page = 1;
      this.stock_total_page = 1;
      // console.log("value", value);

      this.child_tabs.unshift(this.nifty50);
      this.child_tabs = [];
      this.items_data = [];
      this.child_tab = null;

      // Google tag
      if (value == 0) {
        this.$logEvent("securities_watchlist");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_securities_watchlist");
        }
      } else if (value == 1) {
        this.$logEvent("traders_watchlist");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_traders_watchlist");
        }
      } else {
        this.$logEvent("trades_watchlist");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_trades_watchlist");
        }
      }
    },
    child_tab() {
      // this.page_infos.page = 1;
      // this.page_infos.total_page = 1;
      this.hide = true;
      this.page = 1;
      this.stock_total_page = 1;
      // console.log(this.hide);
      this.items_data = [];
    },
  },

  created() {
    this.eventBus.$on("appendStocksTable", (value) => {
      console.log(value, "value");
      // let tabs = this.child_tabs[this.child_tab];
      // var keys = Object(tabs);
      // this.getWatchlistItems(keys.id);
      this.page = value;
      // if (this.mainTab != "Nifty 50") {
      //   console.log("eventbus stock value", value);
      //   let tabs = this.child_tabs[this.child_tab];
      //   var keys = Object(tabs);
      //   let counts = 1;
      //   counts += 1;
      //   this.getWatchlistItems(keys.id, value, counts);
      // }
    });
    this.eventBus.$on("enable-drag", (value) => {
      this.is_draggable = value.is_draggable;
    });
    this.eventBus.$on("getWatchlistName", (value) => {
      this.child_tabs[this.child_tab].name = Object(value).watchlist_name;
    });
    this.eventBus.$on("delete-item", (value) => {
      this.deleteWatchlistItems(value.item);
    });
    this.eventBus.$on("refresh-stock-table", () => {
      let tabs = this.child_tabs[this.child_tab];
      var keys = Object(tabs);
      this.getWatchlistItems(keys.id);
    });
    this.eventBus.$on("refresh-traders-list", (value) => {
      this.getWatchlistItems(value.id);
    });
    this.eventBus.$on("filter-and-sort", (value) => {
      let tabs = this.child_tabs[this.child_tab];
      var keys = Object(tabs);
      this.exchange = value.exchange;
      this.status = value.status;
      this.duration = value.duration;
      this.percentChange = value.percentChange;
      this.ltp = value.last_trade;

      console.log(this.percentChange);
      if (this.selectedTab == "stock") {
        if (value.alpha == 1) {
          this.alpha = "stock__name";
        } else if (value.alpha == 2) {
          this.alpha = "-stock__name";
        } else {
          this.alpha = "";
        }
        if (value.percentChange == 1) {
          this.percentChange = "stock__percent_change";
        } else if (value.percentChange == 2) {
          this.percentChange = "-stock__percent_change";
        } else {
          this.percentChange = null;
        }
        if (value.ltp == 1) {
          this.ltp = "stock__live_price";
        } else if (value.ltp == 2) {
          this.ltp = "-stock__live_price";
        } else {
          this.ltp = null;
        }
      }
      if (this.selectedTab == "trade") {
        if (value.alpha == 1) {
          this.alpha = "trade__security__name";
        } else if (value.alpha == 2) {
          this.alpha = "-trade__security__name";
        } else {
          this.alpha = "";
        }
        if (value.percentChange == 1) {
          this.percentChange = "trade__security__percent_change";
        } else if (value.percentChange == 2) {
          this.percentChange = "-trade__security__percent_change";
        } else {
          this.percentChange = null;
        }
        if (value.ltp == 1) {
          this.ltp = "trade__security__live_price";
        } else if (value.ltp == 2) {
          this.ltp = "-trade__security__live_price";
        } else {
          this.ltp = null;
        }
        if (value.profit_loss == 1) {
          this.profit_loss = "trade__pandl_data";
        } else if (value.profit_loss == 2) {
          this.profit_loss = "-trade__pandl_data";
        } else {
          this.profit_loss = null;
        }
      }
      if (this.selectedTab == "trader") {
        if (value.closed == 1) {
          this.closed = "trader__closed_trades";
        } else if (value.closed == 2) {
          this.closed = "-trader__closed_trades";
        } else {
          this.closed = null;
        }
        if (value.accuracy == 1) {
          this.accuracy = "trader__percent";
        } else if (value.accuracy == 2) {
          this.accuracy = "-trader__percent";
        } else {
          this.accuracy = null;
        }
        if (value.holding_period == 1) {
          this.holding_period = "trader__holding_period";
        } else if (value.holding_period == 2) {
          this.holding_period = "-trader__holding_period";
        } else {
          this.holding_period = null;
        }
        if (value.risk_reward == 1) {
          this.risk_reward = "trader__risk";
        } else if (value.risk_reward == 2) {
          this.risk_reward = "-trader__risk";
        } else {
          this.risk_reward = null;
        }
        if (value.avg_trade == 1) {
          this.avg_trade = "trader__avg_trade_return";
        } else if (value.avg_trade == 2) {
          this.avg_trade = "-trader__avg_trade_return";
        } else {
          this.avg_trade = null;
        }
        if (value.roi == 1) {
          this.roi = "trader__days_pnl";
        } else if (value.roi == 2) {
          this.roi = "-trader__days_pnl";
        } else {
          this.roi = null;
        }
      }

      this.getWatchlistItems(keys.id);
    });
  },
  beforeDestroy() {
    this.eventBus.$off("enable-drag");
    this.eventBus.$off("getWatchlistName");
    this.eventBus.$off("delete-item");
    this.eventBus.$off("refresh-stock-table");
    this.eventBus.$off("refresh-traders-list");
    this.eventBus.$off("filter-and-sort");
    this.eventBus.$off("appendStocksTable");
  },
};
</script>

<style lang="scss" scoped>
.search-security {
  color: #333;
  text-align: center;
  font-family: Avenir;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.search-security-desc {
  color: rgba(51, 51, 51, 0.72);
  text-align: center;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.search-img {
  width: 13.73813rem;
  height: 6.2145rem;
}
.child-tabs {
  border-bottom: 3px solid #e9e9e9;
}
.tab-border {
  border-radius: 10px;
}
.tab-bg-color {
  background-color: #d5e8ff;
  border-radius: 10px;
}

.parent_tab-text {
  //   color: #2d8cff;
  font-size: 17px;
  font-weight: 800;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
}
.child-tab-text {
  font-size: 17px;
  font-weight: 800;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
}

@media only screen and (max-width: 768px) {
  .search-img {
    width: 6.142rem;
    height: 1.51231rem;
  }
  .search-security {
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 800;
    line-height: 1.25rem; /* 111.111% */
  }
  .search-security-desc {
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .tab-bg-color {
    background-color: #2d8cff;
    border-radius: 6px;
  }
  .parent-tab-text {
    font-size: 14px;
    line-height: 20px;
    // color: white;
  }
  .tab-bg-color {
    color: white;
  }
}

::v-deep.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  display: none !important;
}
</style>
